'use strict';

module.exports = ({
    collapsibleHeaderSelector = '[data-collapsible-header]',
    collapsibleSelector = '[data-collapsible]'
} = {}) => {
    $(document).on('click', collapsibleHeaderSelector, function (e) {
        e.preventDefault();

        var $parent = $(this).closest(collapsibleSelector);
        $parent.toggleClass('active');

        // Actualiza aria-expanded para accesibilidad
        var isActive = $parent.hasClass('active');
        $(this).attr('aria-expanded', isActive);
    });
};